import CSS from 'csstype';
import theme from 'styles/theme';

type CSSProps = { [P in keyof CSS.Properties<string | number>]: any };
type CSSProperties<T> = { [P in keyof T]: CSSProps | CSSProperties<any> };
export type Theme = typeof theme;

export function defineStyles<T>(definer: (theme: Theme) => CSSProperties<T>) {
  return (theme: any) => {
    const styles = definer(theme);
    return styles as { [P in keyof T]: any };
  };
}

export type Classes<T extends (...args: any[]) => any> = { [P in keyof ReturnType<T>]: string };
